import './App.css';
import { ProtContainer } from './components/ProtContainer';


function App() {
  return (
    <div >
      
      <ProtContainer/>
    </div>
  );
}

export default App;
